import { app } from '../../../app';

app.factory('HardTokenLoginService', HardTokenLoginService);
/** @ngInject */
function HardTokenLoginService($resource) {
    // hardtoken/u2floginstart POST
    return $resource('app/rest/hardtoken/u2floginstart', {}, {});


}


// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-login/hard-token-login.service.js